var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "27) Icon/checkmark-circle-fill"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Icon \xD0\xA1olor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.6393 31.6181L38.603 51.3681C37.9842 52.1811 37.0263 52.6617 36.0059 52.6683H35.9828C34.9723 52.6683 34.0177 52.2009 33.3923 51.4043L25.387 41.1771C24.2678 39.7485 24.518 37.678 25.9498 36.5589C27.3784 35.4364 29.4522 35.6866 30.5713 37.1218L35.9466 43.9882L48.4023 27.6319C49.5017 26.1868 51.5656 25.9038 53.0172 27.0065C54.4623 28.1092 54.7421 30.173 53.6393 31.6181ZM39.5016 6.58496C21.3218 6.58496 6.58496 21.3218 6.58496 39.5016C6.58496 57.6782 21.3218 72.4183 39.5016 72.4183C57.6815 72.4183 72.4183 57.6782 72.4183 39.5016C72.4183 21.3218 57.6815 6.58496 39.5016 6.58496Z",
    fill: "#56CD7A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_317_378",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 67,
    height: 67
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Icon \xD0\xA1olor_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.6393 31.6181L38.603 51.3681C37.9842 52.1811 37.0263 52.6617 36.0059 52.6683H35.9828C34.9723 52.6683 34.0177 52.2009 33.3923 51.4043L25.387 41.1771C24.2678 39.7485 24.518 37.678 25.9498 36.5589C27.3784 35.4364 29.4522 35.6866 30.5713 37.1218L35.9466 43.9882L48.4023 27.6319C49.5017 26.1868 51.5656 25.9038 53.0172 27.0065C54.4623 28.1092 54.7421 30.173 53.6393 31.6181ZM39.5016 6.58496C21.3218 6.58496 6.58496 21.3218 6.58496 39.5016C6.58496 57.6782 21.3218 72.4183 39.5016 72.4183C57.6815 72.4183 72.4183 57.6782 72.4183 39.5016C72.4183 21.3218 57.6815 6.58496 39.5016 6.58496Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_317_378)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.33a667d244fd8ed390481b860aae0b35.svg";
export { ForwardRef as ReactComponent };